import { ApiBase } from "../../core/api-base";
import { z } from "zod";
import {
    LookupAddressByPostalCode200Response,
    UpdateItem200Response,
    UpdateItemBody,
} from "../../api/generated/users.zod";

export type UserEditUpdateProfileRequest = z.infer<typeof UpdateItemBody>;
export type UserEditUpdateProfileResponse = z.infer<typeof UpdateItem200Response>;
export type UserEditAddressLookupResponse = z.infer<typeof LookupAddressByPostalCode200Response>;

export class UserEditApi extends ApiBase {
    public static async updateProfile(userId: number, requestData: UserEditUpdateProfileRequest): Promise<Response> {
        const url = `/api/v1/users/${userId}`;
        return this.interceptAuthErrors(await super.apiPut(url, requestData));
    }

    public static requestAddressLookupByZip(zipCode: string): Promise<Response> {
        return super.apiGet(`/api/v1/users/address/lookup?postal_code=${encodeURIComponent(zipCode)}`, {
            noSpinner: true,
        });
    }
}

export async function requestUserAddressLookupByZip(zipCode: string): Promise<Response> {
    return UserEditApi.requestAddressLookupByZip(zipCode);
}
